import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Heading from "UI/Heading";

import BlankStoriesList from "../components/BlankStates/BlankStoriesList";
import Container from '../components/Container';
import CreateStoryButton from "../components/CreateStoryButton";
import CreateStoryDialog from "../components/CreateStoryDialog";
import StoryCard from '../components/StoryCard';
import StoryListItemSkeleton from '../components/Skeletons/StoryListItemSkeleton';
import Bookmark from "UI/Heroicons/Bookmark";
import BlankMedia from "Components/BlankStates/BlankMedia";

class StoryListController extends React.Component
{
    state = {
        creatingStory: false
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired,
        stories: PropTypes.array.isRequired,
    };

    render()
    {
        const { stories } = this.props;

        const title = <div className='flex'>
            <Bookmark className='w-7 mr-3' />Stories
        </div>;

        return <Container>
            <Heading
                title={title}
                description='Create your story. This is where you can showcase your case study and show exactly how you’ve helped.'
                actions={<CreateStoryButton />}
            />
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6'>
                {
                    this.props.loading ? <StoryListItemSkeleton /> : _.map(
                        stories,
                        story => <StoryCard key={story.id} story={story} />
                    )
                }
            </div>
            {
                this.renderBlankState()
            }
            {
                <CreateStoryDialog
                    open={this.state.creatingStory}
                    onClose={() => this.setState({creatingStory: false})}
                />
            }
        </Container>;
    }

    renderBlankState()
    {
        if (this.props.loading) {
            return null;
        }

        if (this.props.stories.length > 0) {
            return null;
        }

        return <div className='relative'>
            <BlankStoriesList className='text-gray-600 absolute right-0 mr-16 -mt-12 w-52' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    accountId: state.currentAccountId,
    stories: _.filter(state.stories, story => story.account_id === state.currentAccountId),
});

export default connect(mapStateToProps)(StoryListController);
